const fieldsContentSectionGroup = `
  id
  ...on ContentSectionGroup {
    name
    questionsIds
    requiredGrading
  }
`;

export default fieldsContentSectionGroup;
